export function CashManagementIcon() {
  return (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="15" rx="7.5" fill="url(#paint0_linear_638_27879)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20001 3.19995C6.77566 3.19995 6.36869 3.36852 6.06864 3.66858C5.76858 3.96864 5.60001 4.3756 5.60001 4.79995V7.99995C5.60001 8.4243 5.76858 8.83126 6.06864 9.13132C6.36869 9.43138 6.77566 9.59995 7.20001 9.59995V4.79995H15.2C15.2 4.3756 15.0314 3.96864 14.7314 3.66858C14.4313 3.36852 14.0244 3.19995 13.6 3.19995H7.20001ZM8.80001 7.99995C8.80001 7.5756 8.96858 7.16864 9.26864 6.86858C9.56869 6.56852 9.97566 6.39995 10.4 6.39995H16.8C17.2244 6.39995 17.6313 6.56852 17.9314 6.86858C18.2314 7.16864 18.4 7.5756 18.4 7.99995V11.2C18.4 11.6243 18.2314 12.0313 17.9314 12.3313C17.6313 12.6314 17.2244 12.8 16.8 12.8H10.4C9.97566 12.8 9.56869 12.6314 9.26864 12.3313C8.96858 12.0313 8.80001 11.6243 8.80001 11.2V7.99995ZM13.6 11.2C14.0244 11.2 14.4313 11.0314 14.7314 10.7313C15.0314 10.4313 15.2 10.0243 15.2 9.59995C15.2 9.1756 15.0314 8.76864 14.7314 8.46858C14.4313 8.16852 14.0244 7.99995 13.6 7.99995C13.1757 7.99995 12.7687 8.16852 12.4686 8.46858C12.1686 8.76864 12 9.1756 12 9.59995C12 10.0243 12.1686 10.4313 12.4686 10.7313C12.7687 11.0314 13.1757 11.2 13.6 11.2Z"
        fill="#B17518"
      />
      <rect x="0.5" y="0.5" width="23" height="15" rx="7.5" stroke="#F1B962" />
      <defs>
        <linearGradient
          id="paint0_linear_638_27879"
          x1="21.3559"
          y1="1.94426e-06"
          x2="1.19559"
          y2="1.43189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B861" />
          <stop offset="1" stopColor="#FEE7C2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
